import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import { Invoice, InvoiceFilters } from '../interfaces/invoice';
import { apiService } from '../../shared/services/apiService';
import { getFilteredTruthyFieldsObj } from '../../shared/utils/sortingAndGroupingUtil';
import { InvoiceCustomersResponse } from '../interfaces/invoiceCustomer';

type GetInvoiceHistoryResponse = SpringPagination<Invoice[]>;

export const invoicesService = {
  async getInvoiceHistory(entityId: number, params: InvoiceFilters) {
    const filteredParams = getFilteredTruthyFieldsObj(params);

    const response = await apiService.post<GetInvoiceHistoryResponse>(
      `/api/entity/${entityId}/payment/invoice-history`,
      filteredParams,
    );

    return response.data;
  },

  async getInvoiceDetails(
    entityId: number,
    invoiceId: number,
    isRunGlobalSpinner = false,
  ) {
    const response = await apiService.get<InvoiceCustomersResponse>(
      `/api/entity/${entityId}/payment/invoice/${invoiceId}/details`,
      {
        isRunGlobalSpinner,
      },
    );

    return response.data;
  },
};
